<ng-container *hasPermission="['ORGANIZATION_CONFIG_READ','ORGANIZATION_CONFIG_ALL', 'SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Deposito giudiziario - <b>{{detail_title}}</b></h2>
        </div>
        <form name="guardianForm" #f="ngForm" (ngSubmit)="onSubmit(f)">

            <h5 class="mt-2">Anagrafica</h5>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="companyName" class="form-label">Ragione sociale</label>
                    <input type="text" class="form-control" id="companyName" name="companyName" ngModel
                        [(ngModel)]="guardian.companyName" required />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="vat" class="form-label">P. IVA</label>
                    <input type="text" class="form-control" id="vat" name="vat" ngModel [(ngModel)]="guardian.vat"
                        required />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 mb-3">
                    <label for="address" class="form-label">Indirizzo</label>
                    <input type="text" class="form-control" id="address" name="address" ngModel
                        [(ngModel)]="guardian.address" required />
                </div>
            </div>
            <app-city-autocomplete idPrefix="guardian" [city]="guardian.city"
                (cityChange)="guardian.city = $event" [province]="guardian.province"
                (provinceChange)="guardian.province = $event" [postalCode]="guardian.postalCode"
                (postalCodeChange)="guardian.postalCode = $event">
            </app-city-autocomplete>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="phone" class="form-label">Telefono</label>
                    <input type="text" class="form-control" id="phone" name="phone" ngModel
                        [(ngModel)]="guardian.phone" />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="email" class="form-label">Email</label>
                    <input type="email" class="form-control" id="email" name="email" ngModel
                        [(ngModel)]="guardian.email" email />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <div class="form-check form-switch mt-2">
                        <input class="form-check-input" type="checkbox" role="switch" id="authorizedByPrefect"
                            name="authorizedByPrefect" [(ngModel)]="guardian.authorizedByPrefect" />
                        <label class="form-check-label" for="authorizedByPrefect">Autorizzato dal Prefetto</label>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-4">
                <h5 class="m-0">Sedi</h5>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="addAddress()">
                    <i class="fa-solid fa-plus me-1"></i>Aggiungi sede
                </button>
            </div>

            <div *ngIf="!guardian.addresses || guardian.addresses.length === 0" class="text-muted mt-2 mb-2">
                Nessuna sede inserita.
            </div>

            <div class="address-card mt-2" *ngFor="let address of guardian.addresses; let i = index">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-bold">Sede #{{i + 1}}</span>
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeAddress(i)"
                        [disabled]="guardian.addresses!.length <= 1">
                        <i class="fa-solid fa-trash"></i>
                    </button>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label [for]="'addrName'+i" class="form-label">Nome</label>
                        <input type="text" class="form-control" [id]="'addrName'+i" [name]="'addrName'+i" ngModel
                            [(ngModel)]="address.name" required />
                    </div>
                    <div class="col-md-6 mb-3">
                        <label [for]="'addrAddress'+i" class="form-label">Indirizzo</label>
                        <input type="text" class="form-control" [id]="'addrAddress'+i" [name]="'addrAddress'+i" ngModel
                            [(ngModel)]="address.address" required />
                    </div>
                </div>
                <app-city-autocomplete [idPrefix]="'addr' + i" [city]="address.city"
                    (cityChange)="address.city = $event" [province]="address.province"
                    (provinceChange)="address.province = $event" [postalCode]="address.postalCode"
                    (postalCodeChange)="address.postalCode = $event">
                </app-city-autocomplete>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label [for]="'addrPhone'+i" class="form-label">Telefono</label>
                        <input type="text" class="form-control" [id]="'addrPhone'+i" [name]="'addrPhone'+i" ngModel
                            [(ngModel)]="address.phone" />
                    </div>
                    <div class="col-md-6 mb-3">
                        <label [for]="'addrEmail'+i" class="form-label">Email</label>
                        <input type="email" class="form-control" [id]="'addrEmail'+i" [name]="'addrEmail'+i" ngModel
                            [(ngModel)]="address.email" email />
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end  align-items-center mt-3 gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>
                <ng-template [hasPermission]="['ORGANIZATION_CONFIG_DELETE', 'ORGANIZATION_CONFIG_ALL','SAFESTREET_ADMIN']">
                    @if (guardian.id !== undefined) {
                    <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                        Elimina
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['ORGANIZATION_CONFIG_CREATE', 'ORGANIZATION_CONFIG_UPDATE', 'ORGANIZATION_CONFIG_ALL','SAFESTREET_ADMIN']">
                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                </ng-template>
            </div>
        </form>
        <app-confirm-alert [confirmationMessage]="confirmationMessage" [showConfirmationModal]="showConfirmationModal"
            (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
        </app-confirm-alert>
    </div>
</ng-container>
